import {
  IonAlert,
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonInput,
  IonItem,
  IonModal,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTextarea,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import "./EditCustomColumnPopup.scss";
import { ListBox } from "primereact/listbox";
import { utilService } from "../../../../../../services/utilService";
import {
  CustomColumnListResultInterface,
  StatusBoardColumRequestParams,
} from "../../../../StatusBoard.model";
import { statusBoardService } from "../../../../StatusBoard.service";
import { CONSTANTS } from "../../../../../../constants/callcentral.constants";
import { useToast } from "@agney/ir-toast";
import { AnyARecord } from "dns";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  showModal: boolean;
  statusBoardData: any;
  updateTableData: () => void;
}
const EditCustomColumn: React.FC<ContainerProps> = (props) => {
  const Toast = useToast();
  const { t } = useTranslation("statusBoard");

  let [dropDownColumns, setDropDownColumns] = useState<any>([]);
  let [selectedDropDown, setSelectedDropDown] = useState<boolean>(false);
  const [textData, setTextData] = useState<string>();
  const [columnNameValue, setColumnNameValue] = useState<string>("");
let [placeHolderMessage, setPlaceHolderMessage] = useState<string>(
  t("enterTextDefault")
);
  let [selectedType, setSelectedType] = useState<number>();
 let [buttonName, setButtonName] = useState(t("add"));
  let [selectedDropDownId, setSelectedDropDownId] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    getAllColumns();
    setSelectedType(1);
  }, []);
  useEffect(() => {}, [dropDownColumns]);

  const getAllColumns = async () => {
    const params: StatusBoardColumRequestParams = {
      statusBoardId: props.statusBoardData.StatusBoardId,
      reg_code: utilService.getNetwork(),
    };
    const respResult: CustomColumnListResultInterface =
      await statusBoardService.getAllCustomColumnList(params);
    if (respResult.isSuccess) {
      const columns: any = [];
      respResult.columnList.forEach((element) => {
        const dataObj = {
          id: element.id,
          name: element.name,
          site: element.site,
          type: element.type,
          cloumnDetails: JSON.parse(element.value),
        };
        columns.push(dataObj);
      });
      setDropDownColumns(columns);
      setSelectedDropDown(false);
    } else {
    }
  };

  const closeModal = () => {
    props.updateTableData();
  };

const fieldType: any = [
  { key: "textField", code: 1 },
  { key: "dropDown", code: 3 },
];

  const deleteColumn = (dropdown: any) => {
    setShowAlert(true);
  };
  const proceedDelete = () => {
    const params = {
      statusBoardId: props.statusBoardData.StatusBoardId,
      id: selectedDropDownId,
      remove: true,
      reg_code: utilService.getNetwork(),
    };
    addColumn(params);
  };

  const listBoxTemplate = (dropdown: any) => {
    return (
      <div className="ui-helper-clearfix">
        <span className="list-label" title={dropdown.name}>
          {dropdown.name}
        </span>
        <span
          onClick={() => deleteColumn(dropdown)}
          className="list-delete  icon-close"
        ></span>
      </div>
    );
  };

  const onChangeSelectType = (data: any) => {
    if (selectedType !== data.detail.value) {
      const textMessage = "Enter default value for this text-column";
      const selectMessage =
        "Enter option values separated by comma. Eg: option1, option2, option3";
      placeHolderMessage =
        data.detail.value === 1 ? textMessage : selectMessage;
      setPlaceHolderMessage(
  data.detail.value === 1
    ? t("enterTextDefault")
    : t("enterDropdownValues")
);
      setSelectedType(data.detail.value);
    }
  };

  const onAddNewColumn = () => {
    setSelectedType(1);
    setSelectedDropDown(false);
    setColumnNameValue("");
    setTextData("");
  setButtonName(t("add"));
  };

  const onChangeColumnValue = (event: any) => {
    setColumnNameValue(event.detail.value);
  };

  const onChangeTextValue = (event: any) => {
    setTextData(event.detail.value);
  };

  const listBoxChange = (event: any) => {
    setSelectedType(3);
    setColumnNameValue(event.value.name);
    const textData = event.value["cloumnDetails"]
      ? event.value["cloumnDetails"]["value_list"].toString()
      : "";
    setTextData(textData);
  setButtonName(t("update"));
    setSelectedDropDown(true);
    setSelectedDropDownId(event.value.id);
  };

  const isPositiveInteger = () => {
    return columnNameValue.match(/^[0-9]+$/) != null;
  };

  const getData = () => {
    let optionDataModel: any = {
      type: "text",
      value_list: "",
      value: "",
    };

    let textDataModel: any = {
      value: "",
    };

    textDataModel.value = textData;
    optionDataModel.value_list = textData ? textData.split(",") : [];
    const data = selectedType === 1 ? textDataModel : optionDataModel;
    return data;
  };

  const updateColumn = async (params: any) => {
    const respResult: any = await statusBoardService.updateCustomColumnList(
      params
    );
    if (respResult.isSuccess) {
      setTextData("");
      setColumnNameValue("");
      getAllColumns();
    Toast.success(t("customColumnsUpdated"));
    } else {
      Toast.error(respResult.message);
    }
  };

  const addColumn = async (params: any) => {
    const respResult: any = await statusBoardService.addCustomColumnList(
      params
    );
    if (respResult.isSuccess) {
      setTextData("");
      setColumnNameValue("");
      getAllColumns();
      if (params.remove) {
  Toast.success(t("customColumnsDeleted"));
} else {
  Toast.success(t("customColumnsAdded"));
}
    } else {
      Toast.error(respResult.message);
    }
  };

  const addCustomColumn = () => {
    if (!isPositiveInteger()) {
      if (selectedDropDown) {
        const params = {
          id: selectedDropDownId,
          name: columnNameValue,
          type: selectedType,
          value: JSON.stringify(getData()),
          reg_code: utilService.getNetwork(),
        };
        updateColumn(params);
      } else {
        const params = {
          statusBoardId: props.statusBoardData.StatusBoardId,
          name: columnNameValue,
          type: selectedType,
          data: JSON.stringify(getData()),
          reg_code: utilService.getNetwork(),
        };
        addColumn(params);
      }
    } else {
      Toast.error(t("invalidColumnName"));
    }
  };

  const handleKeyPress = (e:any) => {
    const charCode = e.charCode;
    if ((charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
      e.preventDefault(); 
    }
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="edit-sboard-column-popup"
    >
      <div className="edit-custom-column-cont">
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonTitle className="title">
              {" "}
            {t("newCustomColumn")}
              <span
                className="close-popup icon-close"
                onClick={closeModal}
              ></span>
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid>
            <IonRow>
              <IonCol size="4" className="list-box-col">
                <div className="list-wrapper">
                  <span className="list-title">{t("dropDownList")}</span>
                  <ListBox
                    className="list-box-cont"
                    optionLabel="name"
                    options={dropDownColumns}
                    itemTemplate={listBoxTemplate}
                    onChange={(e) => listBoxChange(e)}
                  />
                </div>
              </IonCol>
              <IonCol size="8">
                <div className="button-cont">
                  <IonButton
                    className="btn add-col-btn"
                    onClick={onAddNewColumn}
                  >
                    <i className=" icon-add i"></i>
                    <span>{t("newColumn")}</span>
                  </IonButton>
                </div>

                <div className="field-cont">
                  <IonItem>
                    <IonSelect
                      value={selectedType}
                      className="type-select"
                      placeholder={t("textField")}
                      onIonChange={(e) => {
                        onChangeSelectType(e);
                      }}
                      disabled={selectedDropDown ? true : false}
                    >
                      {fieldType.map((item: any) => (
                        <IonSelectOption key={item.code} value={item.code}>
                          {t(item.key)}
                        </IonSelectOption>
                      ))}
                    </IonSelect>
                  </IonItem>
                  <IonItem>
                    <IonInput
                      maxlength={60}
                      value={columnNameValue}
                      className="input-name"
                      placeholder={t("columnName")}
                      disabled={selectedDropDown ? true : false}
                      onIonChange={(event) => onChangeColumnValue(event)}
                      onKeyPress={handleKeyPress}
                    ></IonInput>
                  </IonItem>
                </div>
                <IonItem className="ion-text-area-item">
                  <IonTextarea
                    value={textData}
                    className="col-text-area"
                    placeholder={placeHolderMessage}
                    onIonChange={(event) => onChangeTextValue(event)}
                  ></IonTextarea>
                </IonItem>
                <IonButton
                  className="btn update-col-btn"
                  disabled={columnNameValue === "" ? true : false}
                  onClick={addCustomColumn}
                >
                  <span>{buttonName}</span>
                </IonButton>
              </IonCol>
            </IonRow>
            <IonAlert
              isOpen={showAlert}
              onDidDismiss={() => setShowAlert(false)}
              cssClass=""
              header={t("confirmation")}
            message={t("deleteColumnConfirmation")}
              buttons={[
                {
                  text: t("no"),
                  role: "cancel",
                  cssClass: "secondary",
                  handler: () => {
                    setShowAlert(false);
                  },
                },
                {
                  text: t("yes"),
                  handler: () => {
                    proceedDelete();
                  },
                },
              ]}
            />
          </IonGrid>
        </IonContent>
      </div>
    </IonModal>
  );
};

export default EditCustomColumn;
